<template>
  <!-- 头部 -->
  <div class="header-container">
    <div class="header-main">
      <div class="left">
        <img class="logo-top" src="@/assets/images/logo-gxzx.png" alt="重庆市工业和信息化发展中心">
        <div class="left-bottom">
          <a :href="etccLink" target="_blank">
            <img src="@/assets/images/logo-dzsw.png" alt="">
          </a>
          <a :href="sciiieLink" target="_blank">
            <img src="@/assets/images/logo-zbhmsc.png" alt="">
          </a>
        </div>
      </div>
      <div class="search-box">
        <div class="search-box-wrapper">
          <input class="search-input" type="text" autocomplete="false" placeholder="请输入搜索关键字" maxlength="15" v-model="keyword">
          <i class="iconfont icon-sousuo"></i>
          <div class="search-btn-box" @click="toSearch">
            <span>搜索</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Header",
  props: {
    etccLink: {
      type: String,
      default: ''
    },
    sciiieLink: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      keyword: ''
    }
  },
  computed: {

  },
  methods: {
    toSearch() {
      let keyword = this.keyword.trim()
      let routeUrl = this.$router.resolve({
        path: "/search",
        query: {keyword}
      });
      window.open(routeUrl .href, '_blank');
    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="less">
.header-container
{
  position: relative;
  width:100%;
  height:220px;
  background: url(/src/assets/images/header-bg1.jpg) center center no-repeat;
  background-size: cover;
  box-sizing:border-box;
  .header-main {
    box-sizing: border-box;
    width: 1336px;
    height: 220px;
    margin: 0 auto;
    padding-right: 10px;
    padding-left: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .logo-top {
        width: 654px;
        height: auto;
        margin-bottom: 16px;
      }
      .left-bottom {
        display: flex;
        align-items: center;
        img {
          width: auto;
          height: 32px;
          &:first-child {
            margin-right: 42px;
          }
        }
      }
    }
    .search-box {
      /*position: absolute;
      right: 400px;
      top: 100px;*/
      width: 420px;
      height: 46px;
      margin-top: 60px;
      .search-box-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        input.search-input {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          border-radius: 60px;
          border: none;
          background-color: #F6F6F6;
          color: #333;
          outline: none;
          font-size: 16px;
          padding-left: 40px;
          padding-right: 50px;
        }
        input::-webkit-input-placeholder {
          color: #8291B0 !important;
        }
        input:-moz-placeholder {
          color: #8291B0 !important;
        }
        input::-moz-placeholder {
          color: #8291B0 !important;
        }
        input:-ms-input-placeholder {
          color: #8291B0 !important;
        }
        .icon-sousuo {
          position: absolute;
          left: 18px;
          top: 52%;
          color: #989898;
          font-size: 18px;
          font-weight: 700;
          transform: translate(0, -50%);
          transform-origin: 25% 25%;
        }
        .search-btn-box {
          position: absolute;
          right: 18px;
          top: 0;
          height: 100%;
          border-radius: 60px;
          display: flex;
          align-items: center;
          line-height: 46px;
          color: @baseTitleColor;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
        }
      }
      .search-btn-box i {
        margin-right: 4px;
      }
    }

  }

}

/*@media (min-width: 1200px) and (max-width: 1919px){
  .header-container {
    .search-box {
      position: absolute;
      right: 50px;
      top: 100px;
      width: 420px;
      height: 42px;
    }
  }
}

@media (max-width: 1200px){
  .header-container {
    .search-box {
      position: absolute;
      right: 50px;
      top: 100px;
      width: 420px;
      height: 42px;
    }
  }
}*/

</style>
